<!--
 * @Author: AnNa
 * @Date: 2020-06-06 11:14:12
 * @LastEditors: AnNa
 * @LastEditTime: 2021-05-29 17:58:36
 * @Description: 
-->
<template>
  <div :style="{height: '400px'}">
    <v-chart :forceFit="true" :height="height" :data="data" :scale="scale">
      <v-tooltip :showTitle="false" data-key="item*percent" />
      <v-axis />
      <v-legend data-key="item" />
      <v-pie position="percent" color="item" :vStyle="pieStyle" :label="labelConfig" />
      <v-coord type="theta" :radius="0.7" :innerRadius="0.5" />
    </v-chart>
  </div>
</template>

<script>
  const DataSet = require('@antv/data-set')
  const scale = [{
    dataKey: 'percent',
    min: 0,
    formatter: '.0%'
  }]
  export default {
    components: {},
    props: {
      sourceData: Array
    },
    computed: {
      data() {
        const sourceData = this.sourceData
          .filter(obj => {
            if(obj.item.length>=4){
              obj.item = obj.item.replace(obj.item.substring(4),'...')
            }
            return obj.item.length <= 10 && obj.item.length > 0 && obj.item != '其他'
          })
        console.log(sourceData,'sourceData',this.sourceData,this.sourceData[0]);
        const dv = new DataSet.View().source(sourceData.slice(0, 10))
        dv.transform({
          type: 'percent',
          field: 'count',
          dimension: 'item',
          as: 'percent'
        })
        // console.log(dv);
        return dv.rows
      }
    },
    data() {
      return {
        // 画像
        scale,
        height: 400,
        pieStyle: {
          stroke: '#fff',
          lineWidth: 1
        },
        labelConfig: [
          'percent',
          {
            formatter: (val, item) => {
              return val
            }
          }
        ]
      }
    }
  }
</script>

<style lang="less" scoped>
</style>